import React, { memo, useMemo } from 'react'
import DetailCaption from 'components/TrackingContextCard/DetailCaption'
import { DetailItem } from 'components/TrackingContextCard/DetailItem'
import * as GeoJSON from 'geojson'
import moment from 'moment'
import { POSITION_TYPE } from 'transfix-maps/types'
import { IGeocodingSearchResult } from 'transfix-maps/types/api'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { FormattedDateTime } from 'transfix-ui'
import { getCityStatePostcode } from 'utils/mapbox'
import PopupTitle from './PopupTitle'

export interface IPositionCardProps {
  /**
   * @example { data: { "phoneTimestamp":"2022-06-02T15:08:51Z" }
   */
  properties: GeoJSON.GeoJsonProperties
  /**
   * @default []
   */
  features: IGeocodingSearchResult[]
  /**
   * @default false
   */
  isLoading?: boolean
}

const parseData = (
  data: string | undefined
): { phoneTimestamp: string; sourceType: string; timezone: string } => {
  return JSON.parse(data || '') || {}
}

export const PositionCard = memo<IPositionCardProps>(
  ({ features = [], isLoading = false, properties }) => {
    const { data, type = POSITION_TYPE.PING } = properties || {}
    const { phoneTimestamp = '', sourceType, timezone = '' } = parseData(data)
    const placeName = useMemo(() => getCityStatePostcode(features), [features])
    return (
      <Box width={187}>
        <div>
          <PopupTitle>
            {type === POSITION_TYPE.LAST_PING
              ? 'Current Location'
              : moment(phoneTimestamp).fromNow()}
          </PopupTitle>
        </div>
        <Box mt={3}>
          <DetailItem
            titleWidth={60}
            descriptionWidth={136}
            title='Location'
            value={
              <div>
                <DetailCaption>{isLoading ? <Skeleton /> : placeName}</DetailCaption>
              </div>
            }
            isLoading={false}
          />
          <DetailItem
            titleWidth={60}
            descriptionWidth={136}
            title='Date'
            value={
              <FormattedDateTime
                datetime={phoneTimestamp}
                displayTimezone={timezone}
                format='dateAndYearFullDateAlways'
              />
            }
            isLoading={false}
          />
          <DetailItem
            titleWidth={60}
            descriptionWidth={136}
            title='Time'
            value={
              <FormattedDateTime
                datetime={phoneTimestamp}
                displayTimezone={timezone}
                format='T24HourClock'
                showTimezone
              />
            }
            isLoading={false}
          />
          <DetailItem titleWidth={60} title='Source' value={sourceType} isLoading={false} />
        </Box>
      </Box>
    )
  }
)

export default PositionCard
